import { initializeApp } from 'firebase/app';
import { initializeFirestore } from 'firebase/firestore';
import { initializeAuth, indexedDBLocalPersistence, browserLocalPersistence } from 'firebase/auth';
import { getFunctions } from 'firebase/functions';
import { Capacitor } from '@capacitor/core';

const firebaseConfig = {
  apiKey: "AIzaSyAWHmua7OsZ5p8ta4nUNZv7lYOf8cELlCs",
  authDomain: "london-fresco-9b4fa.firebaseapp.com",
  projectId: "london-fresco-9b4fa",
  storageBucket: "london-fresco-9b4fa.firebasestorage.app",
  messagingSenderId: "476565428306",
  appId: "1:476565428306:web:f1113f69998b3d3013278b"
};

const app = initializeApp(firebaseConfig);

// iOS WKWebView under capacitor://localhost can't reliably hold the streaming
// gRPC connection Firestore uses by default, so requests hang forever. Forcing
// long-polling makes the SDK fall back to HTTP requests, which work everywhere.
export const db = initializeFirestore(app, {
  experimentalForceLongPolling: true,
});
// On Capacitor (iOS WKWebView), the default browser persistence tries to use
// Google's iframe-based auth (gapi.iframes), which fails CORS under
// capacitor://localhost and blocks onAuthStateChanged from ever firing.
// Force IndexedDB persistence to avoid the iframe path.
export const auth = initializeAuth(app, {
  persistence: Capacitor.isNativePlatform()
    ? indexedDBLocalPersistence
    : [indexedDBLocalPersistence, browserLocalPersistence],
});
export const functions = getFunctions(app, 'us-central1');